import React, {useEffect,useState} from 'react';
import {Paginator} from "primereact/paginator";
import {extract} from "../utils";
import _ from "lodash";

export const Navigator = ({value, render, showIndex = undefined, onPage = undefined, extraConfig, ...rest}) => {
    const [contentFirst, setContentFirst] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    useEffect( () => {
        if(showIndex && showIndex !== contentFirst){
            setContentFirst(showIndex)
        }
    }, [showIndex])
    const onContentPageChange = (event) => {
        setContentFirst(event.first);
        setCurrentPage(event.page)
        if(onPage)onPage(event.first, event.page)
    }
    const {showEmpty = false} = extraConfig
    const useValue = _.flattenDeep(value || []).filter( el => showEmpty || !!el)
    return <>
        <Paginator first={contentFirst} onPageChange={onContentPageChange}
            {...extract( {rows:1, totalRecords: useValue.length,
                template:"FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink",
                pageLinkSize: undefined, rowsPerPageOptions: undefined, style: undefined, className: undefined,
                leftContent: undefined, rightContent : undefined,currentPageReportTemplate: undefined,

            }, extraConfig)}
        />

    <div className="image-gallery">
        {render( useValue[contentFirst] )}
    </div></>
}